import React, { useEffect, useState } from 'react'
import { currencyService } from '../services/currencyService'
import { PageHeader } from '../components/ui/PageHeader'
import { DataTable } from '../components/ui/DataTable'

function formatRate(value) {
  if (value === null || value === undefined || value === '') return '—'
  const n = typeof value === 'string' ? parseFloat(value) : Number(value)
  if (!Number.isFinite(n)) return String(value)
  return n.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 12,
  })
}

function formatDateTime(isoOrDate) {
  if (!isoOrDate) return '—'
  const d = new Date(isoOrDate)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  })
}

const Currency = () => {
  const [currencies, setCurrencies] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      setLoading(true)
      try {
        const res = await currencyService.listCurrencies()
        const list = res?.data?.currencies
        if (!cancelled && Array.isArray(list)) {
          setCurrencies(list)
        }
      } catch {
        if (!cancelled) setCurrencies([])
      } finally {
        if (!cancelled) setLoading(false)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [])

  const columns = [
    {
      key: 'currency_code',
      header: 'Code',
      render: (row) => <span className="font-mono font-medium">{row.currency_code}</span>,
    },
    { key: 'currency_name', header: 'Name' },
    { key: 'country', header: 'Country / region' },
    {
      key: 'conversion_rate_with_usd',
      header: 'Units per 1 USD',
      className: 'text-right',
      cellClassName: 'text-right font-mono',
      render: (row) => formatRate(row.conversion_rate_with_usd),
    },
    {
      key: 'updated_at',
      header: 'Last updated',
      render: (row) => formatDateTime(row.updated_at),
    },
  ]

  return (
    <div>
      <PageHeader
        title="Currency"
        subtitle="Reference exchange rates (USD base). Values are updated by the system job; this view is read-only."
      />
      <DataTable
        columns={columns}
        data={currencies}
        loading={loading}
        emptyTitle="No currencies found"
        getRowKey={(row) => row.currency_code}
      />
    </div>
  )
}

export default Currency
